import React, { useState } from 'react';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import { InterviewType } from '@domain/constant/acca/test/result/interviewType';
import classNames from 'classnames/bind';
import styles from './questionGuides.module.scss';

const cx = classNames.bind(styles);

const questionGuideTabList: { title: string; type: InterviewType }[] = [
  {
    title: '실무 면접 대비',
    type: 'WORK',
  },
  {
    title: '인성 면접 대비',
    type: 'PERSONALITY',
  },
];

const QuestionGuides = () => {
  const [activeTab, setActiveTab] = useState<InterviewType>('WORK');

  const { accaResultStore } = useResultStore();
  const { accJobCuration } = accaResultStore;

  if (!accJobCuration) return null;

  const { questions } = accJobCuration;

  const tabListEl = questionGuideTabList.map((questionGuideTab) => {
    const { title, type } = questionGuideTab;
    const isOn = activeTab === type;
    const handleClick = () => () => setActiveTab(type);

    return (
      <li key={type} className={cx('listItem')}>
        <a className={cx('tab', { active: isOn })} onClick={handleClick()} role="button">
          {title}
        </a>
      </li>
    );
  });

  const contentListEl = questions?.map((accJobCurationQuestion, index) => {
    const { type, question, comment, priority } = accJobCurationQuestion;
    if (type !== activeTab) return;

    return (
      <li key={index} className={cx('listItem')}>
        <span className={cx('order')}>Q{priority}.</span>
        <div className={cx('qaWrapper')}>
          <em className={cx('question')}>{question}</em>
          <p className={cx('answer')}>{comment}</p>
        </div>
      </li>
    );
  });

  return (
    <div className={cx('wrapper')}>
      {/* [D] 탭 영역 */}
      <ul className={cx('tabList')}>{tabListEl}</ul>

      {/* [D] 질문 영역 */}
      <ol className={cx('contentList')}>{contentListEl}</ol>
    </div>
  );
};

export default QuestionGuides;
